// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export function initCrispChat() {
    window.$crisp = []
    window.CRISP_WEBSITE_ID = '41cef12d-d42c-4ae8-9694-a73d18eb4ef3'
    const script = document.createElement('script')
    script.src = 'https://client.crisp.chat/l.js'
    script.async = true
    document.head.appendChild(script)
}
